// src/stone/illustrations/StonjiChartBlackIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiChartBlackIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 112 112",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M0 0h112v112H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M21 77.035a7 7 0 0 1 7 7v14H14v-14a7 7 0 0 1 7-7M44.334 56.035a7 7 0 0 1 7 7v35h-14v-35a7 7 0 0 1 7-7M67.667 63.035a7 7 0 0 1 7 7v28h-14v-28a7 7 0 0 1 7-7M91 42.035a7 7 0 0 1 7 7v49H84v-49a7 7 0 0 1 7-7"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m34.24 42.57 40.414-23.333 3.5 6.063-40.415 23.333a3.5 3.5 0 1 1-3.5-6.062"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M79.435 20.519a3.5 3.5 0 1 1-6.062 3.5 3.5 3.5 0 0 1 6.062-3.5"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m59.279 14.057 18.03 4.83-1.811 6.762-18.03-4.831a3.5 3.5 0 0 1 1.811-6.762"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m74.953 41.205 4.832-18.03-6.762-1.812-4.831 18.03a3.5 3.5 0 1 0 6.761 1.812"
        }
      )
    ]
  }
);
var StonjiChartBlackIllustration_default = StonjiChartBlackIllustration;

export {
  StonjiChartBlackIllustration,
  StonjiChartBlackIllustration_default
};
